import { render } from "./accountcomponent.vue?vue&type=template&id=45d0c148&scoped=true"
import script from "./accountcomponent.vue?vue&type=script&lang=js"
export * from "./accountcomponent.vue?vue&type=script&lang=js"

import "./accountcomponent.vue?vue&type=style&index=0&id=45d0c148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d0c148"]])

export default __exports__